import { render, staticRenderFns } from "./-listing.vue?vue&type=template&id=27ac5ef3"
import script from "./-listing.vue?vue&type=script&lang=js"
export * from "./-listing.vue?vue&type=script&lang=js"
import style0 from "./-listing.vue?vue&type=style&index=0&id=27ac5ef3&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports